<template>
    <common-page-split>
        <template #aside>
            <common-content-spacer height="small">
                <div class="appointment__months-switch">
                    <schedule-months-switch
                        :value="{ year, month }"
                        :options="dateOptions"
                        size="small"
                        @change="changeCurrentMonth($event)"
                    ></schedule-months-switch>
                </div>

                <availability-calendar-small :year="year" :month="month"></availability-calendar-small>

                <div>
                    <common-icon name="location" size="medium-large"></common-icon>
                    <span class="availability-schedule--aside-text">
                        {{ locationName }}
                    </span>
                </div>
                <div>
                    <common-icon name="time" size="medium-large"></common-icon>
                    <span class="availability-schedule--aside-text">
                        {{ $t('pages.availability.index.labels.appointment_length', { length: schedule.appointmentLength }) }}
                    </span>
                </div>
                <common-button
                    :label="$t('pages.availability.index.buttons.modify_availability')"
                    :isDisabled="isAvailabilityDisabled"
                    class="availability-schedule--mb-10"
                    type="secondary"
                    size="large"
                    @click="emitEvent({ name: 'modify-availability' })"
                ></common-button>

                <common-content-group>
                    <common-content-spacer height="tiny">
                        <availability-status
                            :label="$t('pages.availability.index.statuses.completed')"
                            type="completed"
                        ></availability-status>
                        <availability-status
                            :label="$t('pages.availability.index.statuses.confirmed')"
                            type="confirmed"
                        ></availability-status>
                        <availability-status
                            :label="$t('pages.availability.index.statuses.pending')"
                            type="pending"
                        ></availability-status>
                        <availability-status
                            class="availability-status-box--cancelled-hover"
                            :label="$t('pages.availability.index.statuses.cancelled')"
                            type="cancelled"
                            @show-cancelled="changeShowCancelled($event)"
                        ></availability-status>
                    </common-content-spacer>
                </common-content-group>
            </common-content-spacer>
        </template>

        <template #main>
            <availability-full-calendar
                :year="year"
                :month="month"
                :dates="dates"
                :physician="user"
                :practice="practice"
                :location="location"
                :showCancelled="showCancelled"
                @schedule-changed="getCalendarDays()"
            >
                <schedule-months-switch
                    :value="{ year, month }"
                    :options="dateOptions"
                    :disableMonths="false"
                    size="large"
                    @change="changeCurrentMonth($event)"
                ></schedule-months-switch>
            </availability-full-calendar>
        </template>
    </common-page-split>
</template>

<script>
    import dayjs from 'dayjs'
    import UsersAPI from 'api/UsersAPI'
    import AvailabilityStatus from './availability/AvailabilityStatus'
    import AvailabilityCalendarSmall from './availability/AvailabilityCalendarSmall'
    import AvailabilityFullCalendar from './availability/AvailabilityFullCalendar'
    import ScheduleMonthsSwitch from './referrals-new-schedule/ScheduleMonthsSwitch'

    export default {
        components: {
            AvailabilityStatus,
            AvailabilityCalendarSmall,
            ScheduleMonthsSwitch,
            AvailabilityFullCalendar,
        },

        props: {
            schedule: { type: Object, required: true },
            practice: { type: Object, required: true },
            user: { type: Object, required: true },
            practiceLocationId: { type: Number, default: undefined },
        },

        data() {
            return {
                location: null,
                year: dayjs().year(),
                month: dayjs().month(),
                dates: {},
                showCancelled: false,
            }
        },

        computed: {
            dateOptions() {
                return Array(12)
                    .fill(dayjs())
                    .map((month, index) => ({
                        label: month.add(index, 'months').format('MMMM YYYY'),
                        value: {
                            year: month.add(index, 'months').year(),
                            month: month.add(index, 'months').month(),
                        },
                    }))
            },

            isAvailabilityDisabled() {
                return (
                    !this.$auth.getUser().canModifyPracticeMemberAvailability &&
                    this.$auth.getUser().id !== this.$auth.getActiveMember().id
                )
            },

            locationName() {
                if (this.$route.query.locationId) {
                    return this.$auth
                        .getPractice()
                        .locations.filter((location) => location.id === Number(this.$route.query.locationId))
                        .map((location) => location.name)[0]
                }
                return this.$t('pages.availability.index.labels.main_location')
            },
        },

        methods: {
            changeCurrentMonth({ year, month }) {
                this.year = year
                this.month = month
                this.getCalendarDays()
            },

            getCalendarDays() {
                const startOfMonth = dayjs()
                    .set('month', this.month)
                    .set('year', this.year)
                    .startOf('month')
                    .startOf('day')
                    .format('YYYY-MM-DD')
                const endOfMonth = dayjs()
                    .set('month', this.month)
                    .set('year', this.year)
                    .endOf('month')
                    .startOf('day')
                    .format('YYYY-MM-DD')
                this.getSchedule(this.user.id, this.practice.id, startOfMonth, endOfMonth, this.practiceLocationId)
            },

            getSchedule(userId, practiceId, dateFrom, dateTo, practiceLocationId) {
                UsersAPI.getSchedule(userId, practiceId, dateFrom, dateTo, practiceLocationId).then((res) => (this.dates = res))
            },

            changeShowCancelled(ev) {
                this.showCancelled = ev.showCancelled
            },
        },

        watch: {
            practiceLocationId() {
                this.getCalendarDays()
            },
        },

        mounted() {
            this.getCalendarDays()
        },
    }
</script>
